import { defineMessages } from 'react-intl';

export default defineMessages({
	resetPasswordLink: {
		defaultMessage: 'Reset password',
		description: 'Text of the reset password link',
		id: 'cv.login.reset.password.link',
	},
	resetPasswordLinkInlineBold: {
		defaultMessage: 'Reset Password',
		description: 'Text of the reset password which is inline bold',
		id: 'cv.login.reset.password.link.bold',
	},
	createPasswordLink: {
		defaultMessage: 'Create password',
		description: "Text to create password for customers who haven't yet set a password",
		id: 'cv.login.create.a.password.link',
	},
	dontHavePasswordText: {
		defaultMessage: "Don't have a password?",
		description: "Text to prompt user if they don't already have a password due to a new account",
		id: 'cv.login.dont.have.password.text',
	},
	nextButton: {
		defaultMessage: 'Next',
		description: 'Next button label',
		id: 'cv.next.button.label',
	},
	continueButton: {
		defaultMessage: 'Continue',
		description: 'Continue button label',
		id: 'cv.continue.button.label',
	},
	emailLabel: {
		defaultMessage: 'Email address',
		description: 'Label for login email field',
		id: 'cv.login.page.email.label',
	},
	passwordLabelAndPlaceholder: {
		defaultMessage: 'Password',
		description: 'Placeholder and label for login password field',
		id: 'cv.signup.page.password',
	},
	invalidEmailError: {
		defaultMessage: 'Enter a valid email address and try again.',
		description: 'Error shown when the email does not have the correct format.',
		id: 'sd.login.error.invalid.email.error',
	},
	incorrectPasswordError: {
		defaultMessage: 'Incorrect password. Try again',
		description: 'Error shown when the password is incorrect.',
		id: 'sd.login.error.incorrect.password',
	},
	emptyPasswordError: {
		defaultMessage: 'You must enter your password to log in',
		description: 'Error shown when the password is empty',
		id: 'sd.login.error.empty.password',
	},
	accessDeniedErrorCodeMessage: {
		defaultMessage: 'You can’t continue with single sign-on. Try again.',
		description: 'Error shown when receiving access deny error code from identity.',
		id: 'sd.login.errorcode.access.denied',
	},
	defaultErrorCodeMessage: {
		defaultMessage: 'Something went wrong while trying to log you in. Try again.',
		description: 'Error shown when the receiving other error code',
		id: 'sd.login.errorcode.default',
	},
	loginConsentErrorMessage: {
		defaultMessage:
			'Something went wrong while attempting to validate your consent. Try logging in again later',
		description:
			'Error shown when the FedRAMP user failed to consent and got redirected to the login page',
		id: 'sd.login.consent.fail.error',
	},
});
